import type { InterestRatePeriod } from "@aprao/model/src/shapes/ShapeLender.js";

export const labelByInterestRatePeriod: Record<InterestRatePeriod, string> = {
  year: "annual",
  month: "monthly",
};
